// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"L3-z","colorTextValue":"M3-z","swatches":"N3-z","collapseLink":"O3-z","isCollapsed":"P3-z","dropdown":"Q3-z","disabled":"R3-z"};